<div class="wrapper page-heading page-heading-header-bg">
        <div class="row page-heading-left">
            <div class="col-xs-6">
                <h1 [i18n]="'df-management.df-admin.title'"></h1>
            </div>
        </div>
</div>
<section class="container row">
 <div class="col-lg-6 col-sm-6">
    <div class="cardWidget clickable" (click)="countryNavigation()">
        <div class="cardWidget-header">
            <img class="cma-image" src="/assets/charges-icons/country.png">
            <span class="cardWidget-header-title" [i18n]="'df-management.df-admin.widgets.country-title'"></span>
            <i class="indicationIcon fa fa-external-link-alt"></i>
        </div>
    
        <div class="cardWidget-content flex-row">
            <p [i18n]="'df-management.df-admin.widgets.country-description'"></p>
            <i class="iconWidgetButton"></i>
        </div>
    </div>
</div>
<div class="col-lg-6 col-sm-6 card-alignment">
    <div class="cardWidget clickable" (click)="chargesNavigation()">
        <div class="cardWidget-header">
            <img class="cma-image" src="/assets/charges-icons/money-bag.png">
            <span class="cardWidget-header-title" [i18n]="'df-management.df-admin.widgets.charge-title'"></span>
            <i class="indicationIcon fa fa-external-link-alt"></i>
        </div>
    
        <div class="cardWidget-content flex-row">
            <p [i18n]="'df-management.df-admin.widgets.charge-description'"></p>
            <i class="iconWidgetButton"></i>
        </div>
    </div>
</div>
</section>
